export default __webpack_public_path__ + "static/media/BetterHalfBenefit.68054787.png";